enum storageSettings {
  key = 'JobSearchBox',
  behaviorSmooth = 'smooth',
  behaviorInstant = 'auto',
}

export const scrollToResultsWhenRendered = (
  scrollToResultsRef: React.MutableRefObject<HTMLDivElement | null>,
) => {
  const jobSearchBoxData = sessionStorage.getItem(storageSettings.key);
  if (jobSearchBoxData && JSON.parse(jobSearchBoxData).scrollToResults) {
    const behavior = JSON.parse(jobSearchBoxData).behavior ?? storageSettings.behaviorSmooth;
    scrollToResultsRef?.current?.scrollIntoView({ behavior: behavior });
  }
};

export const setScrollInstantOnFilterChangeRerender = () => {
  const jobSearchBoxData = sessionStorage.getItem(storageSettings.key);
  if (jobSearchBoxData && JSON.parse(jobSearchBoxData).scrollToResults) {
    sessionStorage.setItem(
      storageSettings.key,
      JSON.stringify({
        scrollToResults: true,
        behavior: storageSettings.behaviorInstant,
      }),
    );
  }
};

export const enableScrollWhenSearchInitiated = () => {
  sessionStorage.setItem(
    storageSettings.key,
    JSON.stringify({ scrollToResults: true, behavior: storageSettings.behaviorSmooth }),
  );
};

export const clearScrollWhenSearchCriteriaHasChanged = () => {
  sessionStorage.setItem(
    storageSettings.key,
    JSON.stringify({ scrollToResults: false, behavior: storageSettings.behaviorSmooth }),
  );
};
